import React from "react";
import "../App.css";

import Alonso from "../assets/characters_webp/Alonso.webp";
import Alonso_05 from "../assets/characters_webp/Alonso@0.5x.webp";

import Clare from "../assets/characters_webp/Clare.webp";
import Clare_05 from "../assets/characters_webp/Clare@0.5x.webp";

import Geeorgie from "../assets/characters_webp/Geeorgie.webp";
import Geeorgie_05 from "../assets/characters_webp/Geeorgie@0.5x.webp";

import Grzhegozh from "../assets/characters_webp/Grzhegozh.webp";
import Grzhegozh_05 from "../assets/characters_webp/Grzhegozh@0.5x.webp";

import Hiro from "../assets/characters_webp/Hiro.webp";
import Hiro_05 from "../assets/characters_webp/Hiro@0.5x.webp";

import Jim from "../assets/characters_webp/Jim.webp";
import Jim_05 from "../assets/characters_webp/Jim@0.5x.webp";

import Lucy from "../assets/characters_webp/Lucy.webp";
import Lucy_05 from "../assets/characters_webp/Lucy@0.5x.webp";

import Luna from "../assets/characters_webp/Luna.webp";
import Luna_05 from "../assets/characters_webp/Luna@0.5x.webp";

import Marta from "../assets/characters_webp/Marta.webp";
import Marta_05 from "../assets/characters_webp/Marta@0.5x.webp";

import Pain from "../assets/characters_webp/Pain.webp";
import Pain_05 from "../assets/characters_webp/Pain@0.5x.webp";

import Sigurd from "../assets/characters_webp/Sigurd.webp";
import Sigurd_05 from "../assets/characters_webp/Sigurd@0.5x.webp";

/* lowercase, as in your folder */
import Rachel from "../assets/characters_webp/rachel.webp";
import Rachel_05 from "../assets/characters_webp/rachel@0.5x.webp";

const fighters = [
    { name: "Alonso", img: Alonso, img05: Alonso_05, text: "Text about characters" },
    { name: "Clare", img: Clare, img05: Clare_05, text: "Text about characters" },
    { name: "Geeorgie", img: Geeorgie, img05: Geeorgie_05, text: "Text about characters" },
    { name: "Grzhegozh", img: Grzhegozh, img05: Grzhegozh_05, text: "Text about characters" },
    { name: "Hiro", img: Hiro, img05: Hiro_05, text: "Text about characters" },
    { name: "Jim", img: Jim, img05: Jim_05, text: "Text about characters" },
    { name: "Lucy", img: Lucy, img05: Lucy_05, text: "Text about characters" },
    { name: "Luna", img: Luna, img05: Luna_05, text: "Text about characters" },
    { name: "Marta", img: Marta, img05: Marta_05, text: "Text about characters" },
    { name: "Pain", img: Pain, img05: Pain_05, text: "Text about characters" },
    { name: "Rachel", img: Rachel, img05: Rachel_05, text: "Text about characters" },
    { name: "Sigurd", img: Sigurd, img05: Sigurd_05, text: "Text about characters" },
];

const Characters = ({ t }) => {
    const copy = t.characters;

    return (
        <div className="i characters-page">
            <div className="fighters">
                <h1>{copy.title}</h1>
            </div>

            {/* IMPORTANT: remove hover-effect-cover to avoid legacy conflicts */}
            <ul className="fighters-list">
                {fighters.map((f) => (
                    <li
                        key={f.name}
                        style={{ "--char-url": `url(${f.img})` }}  /* for glitch layers */
                    >
                        {/* required for CLEAN glitch version */}
                        <span className="char-glitch" aria-hidden="true"></span>

                        <img
                            src={f.img05}
                            srcSet={`${f.img05} 460w, ${f.img} 921w`}
                            sizes="(max-width: 768px) 78vw, (max-width: 1100px) 33vw, 25vw"
                            alt={f.name}
                            loading="lazy"
                            decoding="async"
                        />

                        <div className="effect-to-top">
                            <h3>{f.name}</h3>
                            <p>{copy.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Characters;
